




export const getFileUrl = (baseUrl: string, fileId: string, token: string): string => {
    let url = [
        baseUrl,
        `?action=hae_tiedosto&varmenne=${token}`,
        `&tiedosto=${fileId}`
    ]
    return url.join("");
};


export const getThumbnailUrl = (baseUrl: string, fileId: string, token: string, height?: number, width?: number): string => {
    let url = [
        baseUrl,
        `?action=hae_naytekuva_tiedosto&varmenne=${token}`,
        `&tiedosto=${fileId}`
    ]
    if (width) {
        url = url.concat(`&leveys=${width}`)
    }
    if (height) {
        url = url.concat(`&korkeus=${height}`)
    }
    return url.join("");
};